export const BookSpeakingLessonCalendarScreenPath = "/book-speaking-lesson";
